<nb-card style="min-width: 480px; max-width: 560px;">
  <nb-card-header>
    <h5 class="mb-0">{{ category ? 'Edit global category' : (parentCategoryId ? 'Add child category' : 'Add root category') }}</h5>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="form">
      <div class="mb-3">
        <label class="form-label">Name <span class="text-danger">*</span></label>
        <input class="form-control" formControlName="name"
          [class.is-invalid]="form.get('name')?.invalid && form.get('name')?.touched">
        <div class="invalid-feedback">Name is required</div>
      </div>
      <div class="mb-3">
        <label class="form-label">Slug</label>
        <input class="form-control" formControlName="slug" placeholder="Optional">
        <small class="text-muted">Generated from name if blank</small>
      </div>
      <div class="mb-3">
        <label class="form-label">Description</label>
        <textarea class="form-control" formControlName="description" rows="2"></textarea>
      </div>
      <div class="mb-3">
        <label class="form-label">Parent category</label>
        <select class="form-select" formControlName="parentCategory">
          <option value="">— Root (no parent) —</option>
          <option *ngFor="let cat of parentOptions" [value]="cat._id">{{ indentLabel(cat) }}</option>
        </select>
      </div>
      <div class="row">
        <div class="col-6 mb-3">
          <label class="form-label">Display order</label>
          <input type="number" class="form-control" formControlName="displayOrder" min="0">
        </div>
        <div class="col-6 mb-3">
          <label class="form-label">Status</label>
          <select class="form-select" formControlName="status">
            <option [ngValue]="1">Active</option>
            <option [ngValue]="0">Inactive</option>
          </select>
        </div>
      </div>
      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox" formControlName="isVisible" id="gcVisible">
        <label class="form-check-label" for="gcVisible">Visible</label>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="d-flex justify-content-end gap-2">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()" [disabled]="saving">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || saving">
      {{ saving ? 'Saving…' : 'Save' }}
    </button>
  </nb-card-footer>
</nb-card>
